import { gql } from 'graphql-request';

export const GET_CERTIFICATES_QUERY = gql`
    query GetCertificatesByUser {
        getCertificatesByUser {
            courseId
            name
            description
            dateCreatedTimestamp
            curriculum {
                id
                name
            }
            division {
                id
                name
            }
            durationInSeconds
            progress
            completedDate
            tags {
                name
            }
        }
    }
`;

export const GET_PROGRESSING_COURSES_QUERY = gql`
    query GetInProgressCourses {
        getInProgressCourses {
            courseId
            name
            description
            dateCreatedTimestamp
            curriculum {
                id
                name
            }
            division {
                id
                name
            }
            durationInSeconds
            progress
            learnMinutes
            completedDate
            coverImageUrl {
                small
                large
            }
        }
    }
`;

